import React, { useEffect } from "react";
import { Row, Col, CardBody, Card, Container } from "reactstrap";

// Redux
import { Link, useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// actions
import { loginUser, loginUserSSO } from "../../store/auth/login/actions";

// import images
import profile from "../../assets/images/profile-img.png";
import logo from "../../assets/images/brands/logo-sm-light.png";
import darkLogo from "../../assets/images/logo-sm-dark.png";
import toastr from "toastr";

//i18n
import { withTranslation } from "react-i18next";

import LoginForm from "./Form/LoginForm";
import ErrorSSO from "./Error/SSO/ErrorSSO";
import Loading from "./Loading/Loading";

const Login = ({ t }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { error, loading, loadingSSO } = useSelector((state) => state.Login);

  const location = useLocation();

  const generateParams = () => {
    const params = location?.search?.toString();

    if (!params) return;

    let newParams = {};

    if (params) {
      const paramsArray = params?.replace("?", "")?.split("&");

      paramsArray?.forEach((v) => {
        const [key, value] = v?.split("=");

        newParams = {
          ...newParams,
          [key]: value,
        };
      });
    }

    return newParams;
  };

  const errorSSO =
    (Object?.keys(generateParams() ?? {})?.find(
      (key) => key === "error_code"
    ) &&
      generateParams()) ||
    (!Array.isArray(error) &&
      Object?.keys(error ?? {})?.find((key) => key === "error_code") &&
      error);

  const validateSSO =
    Object?.keys(generateParams() ?? {})?.find(
      (key) => key === "code_authorization"
    ) && generateParams();

  const handleValidSubmit = (event, values) => {
    event?.preventDefault();
    toastr.clear();
    dispatch(loginUser(values, history));
  };

  useEffect(() => {
    if (validateSSO) {
      dispatch(loginUserSSO(validateSSO, history));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { mainTheme, version } = useSelector((state) => state.Layout);

  if (loadingSSO) return <Loading t={t} />;

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-soft-primary">
                  <Row>
                    <Col className="col-7">
                      <div className="text-primary p-4">
                        <h5 className="text-primary">{t("Welcome Back !")}</h5>
                        <p>{t("Sign in to Real Customer.")}</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="Tech4H" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={mainTheme === "dark" ? logo : darkLogo}
                            alt="Tech4H"
                            className="rounded-circle"
                            height="50"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>

                  {!errorSSO ? (
                    <LoginForm
                      errorData={{
                        error,
                      }}
                      loading={loading}
                      submitCallback={{
                        handleValidSubmit,
                      }}
                      t={t}
                    />
                  ) : (
                    <ErrorSSO errorSSO={errorSSO} t={t} />
                  )}
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>© {new Date().getFullYear()} Tech4humans.</p>
              </div>
              <div className="mt-5 text-center">
                <p>v{version}</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Login);
